import { createToastInterface, POSITION, type PluginOptions } from "vue-toastification";
import ToastContent from "./ToastContent.vue";
import languageManager from "@common/assets/scripts/Translations";
import ErrorIcon from "./icons/error-icon.vue";
import WarningIcon from "./icons/warning-icon.vue";
import SuccessIcon from "./icons/success-icon.vue";
import InfoIcon from "./icons/info-icon.vue";

const icons = {
    error: ErrorIcon,
    success: SuccessIcon,
    warning: WarningIcon,
    info: InfoIcon,
};

const options: PluginOptions = {
    position: POSITION.BOTTOM_RIGHT,
    timeout: 3000,
};

const toast = createToastInterface(options);

class Toast {
    private static showToast(
        type: "error" | "success" | "warning" | "info",
        title: string,
        description: string,
        extraOptions: Record<string, any> = {}
    ) {
        toast[type](
            {
                component: ToastContent,
                props: { title, description },
            },
            {
                icon: icons[type],
                ...extraOptions,
            }
        );
    }

    static error(content: string, title = languageManager.getTranslation("t-error"), options?: Record<string, any>) {
        this.showToast("error", title, content, options);
    }

    static success(
        content: string,
        title = languageManager.getTranslation("t-success"),
        options?: Record<string, any>
    ) {
        this.showToast("success", title, content, options);
    }

    static warning(
        content: string,
        title = languageManager.getTranslation("t-warning"),
        options?: Record<string, any>
    ) {
        this.showToast("warning", title, content, options);
    }

    static info(content: string, title = languageManager.getTranslation("t-info"), options?: Record<string, any>) {
        this.showToast("info", title, content, options);
    }
}

export default Toast;
